import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'tudoaqui-c6d80.firebaseapp.com',
  projectId: 'tudoaqui-c6d80',
  storageBucket: 'tudoaqui-c6d80.appspot.com',
  messagingSenderId: '188185221129',
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const VAPID_KEY = 'BChLO2-J4Cc1_wqhhAtNQJe74p-An94F1Q7Ca9GPKTB8qVW-cux5eFVYq1OU2Tt1I_URy2SqpFV7wF0ZJrWDayA';

let firebaseApp = null;
let messagingInstance = null;

export function getFirebaseApp() {
  if (firebaseApp) return firebaseApp;
  if (getApps().length > 0) {
    firebaseApp = getApps()[0];
    return firebaseApp;
  }
  firebaseApp = initializeApp(firebaseConfig);
  return firebaseApp;
}

export function getFirebaseMessaging() {
  if (messagingInstance) return messagingInstance;
  const app = getFirebaseApp();
  messagingInstance = getMessaging(app);
  return messagingInstance;
}

export async function requestNotificationPermission() {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const messaging = getFirebaseMessaging();
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
}

export function onForegroundMessage(callback) {
  const messaging = getFirebaseMessaging();
  return onMessage(messaging, (payload) => {
    console.log('Foreground message:', payload);
    callback(payload);
  });
}
